var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-7 0 32.84 32.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Select") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .selection-cls1 {\n        fill: inherit;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whiteboard"
  }, /*#__PURE__*/React.createElement("path", {
    className: "selection-cls1",
    d: "m21.77,17.7L0,0v28.06s8.42-4,8.42-4l3.86,8.11c.28.59.99.84,1.58.56l2.8-1.33c.59-.28.84-.99.56-1.58l-3.86-8.11,8.42-4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.af1f84f4524ce9f9d146bade7805fe95.svg";
export { ForwardRef as ReactComponent };